module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-black-mill-finish-724-scale.edebe72b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-black-mill-finish-724-scale.jpg
// module id = 1121
// module chunks = 37